import React from "react";
import {
  Page,
  Text,
  Image,
  Document,
  StyleSheet,
  View,
} from "@react-pdf/renderer";

// ⚠️ IMPORTANT : Mets un vrai base64 complet ou enlève l’image si problème
const logoBase64 = null; // Mets ton vrai logo ici si valide

const styles = StyleSheet.create({
  page: {
    fontFamily: "Helvetica",
    paddingTop: 40,
    paddingBottom: 60,
    paddingHorizontal: 40,
    fontSize: 12,
    lineHeight: 1.5,
  },
  header: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 24,
    borderBottomWidth: 1,
    borderBottomColor: "#000",
    paddingBottom: 10,
  },
  logo: {
    width: 50,
    height: 50,
  },
  title: {
    fontSize: 20,
    fontFamily: "Helvetica-Bold",
    textAlign: "center",
    flexGrow: 1,
    marginTop: 10,
  },
  headerText: {
    fontSize: 8,
    marginBottom: 3,
    textAlign: "right",
  },
  section: {
    marginBottom: 20,
  },
  questionTitle: {
    fontSize: 14,
    fontFamily: "Helvetica-Bold",
    marginBottom: 5,
  },
  text: {
    fontSize: 12,
    marginBottom: 5,
  },
});

const renderComment = (comment, repId) => {
  if (!comment) {
    return <Text style={styles.text}>No comment</Text>;
  }

  return comment.split("\n").map((line, index) => (
    <Text key={`${repId}-${index}`} style={styles.text}>
      {line}
    </Text>
  ));
};

const MyDocument = ({ report, userLang }) => {
  const formattedDate = report?.dateComplete
    ? new Date(report.dateComplete).toLocaleString()
    : "";

  return (
    <Document>
      <Page size="A4" style={styles.page}>
        {/* HEADER */}
        <View style={styles.header}>
          {logoBase64 && <Image style={styles.logo} src={logoBase64} />}

          <Text style={styles.title}>
            {userLang === "EN"
              ? (report?.titleRepportEn ?? "")
              : (report?.titleRepportFr ?? "")}
          </Text>

          <View>
            <Text style={styles.headerText}>Date: {formattedDate}</Text>
            <Text style={styles.headerText}>
              Restaurant: {report?.nomEmplacement ?? ""}
            </Text>
            <Text style={styles.headerText}>
              Author: {report?.username ?? ""}
            </Text>
          </View>
        </View>

        {/* QUESTIONS */}
        {Array.isArray(report?.listeQuestions) &&
          report.listeQuestions.map((q) => (
            <View key={`q-${q.id}`} style={styles.section}>
              <Text style={styles.questionTitle}>
                {userLang === "EN" ? (q?.textEn ?? "") : (q?.textFr ?? "")}
              </Text>

              {/* REPONSES QUESTION PRINCIPALE */}
              {Array.isArray(report?.listeReponses) &&
                report.listeReponses
                  .filter((rep) => rep?.idQuestion === q?.id)
                  .map((rep) => (
                    <View key={`rep-${rep.id}`}>
                      {renderComment(rep?.commentaire, rep.id)}
                    </View>
                  ))}

              {/* SOUS-QUESTIONS */}
              {Array.isArray(q?.childQuestions) &&
                q.childQuestions.map((qc) => (
                  <View key={`qc-${qc.id}`} style={{ marginTop: 10 }}>
                    <Text style={styles.questionTitle}>
                      {userLang === "EN"
                        ? (qc?.textEn ?? "")
                        : (qc?.textFr ?? "")}
                    </Text>

                    {Array.isArray(report?.listeReponses) &&
                      report.listeReponses
                        .filter((rep) => rep?.idQuestion === qc?.id)
                        .map((rep) => (
                          <View key={`rep-${rep.id}`}>
                            {renderComment(rep?.commentaire, rep.id)}
                          </View>
                        ))}
                  </View>
                ))}
            </View>
          ))}
      </Page>
    </Document>
  );
};

export default MyDocument;
